import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import type {
  OpalApiResponseDocument,
  OpalApiRequestParams,
} from '../../schema'

type ReadMeOperation = 'ReadMeV2'
export type ReadMeParams = OpalApiRequestParams<ReadMeOperation>
export type ReadMeResponse = OpalApiResponseDocument<ReadMeOperation, 200>

type ReadUsersOperation = 'ReadUsersV2'
export type ReadUsersParams = OpalApiRequestParams<ReadUsersOperation>
export type ReadUsersResponse = OpalApiResponseDocument<ReadUsersOperation, 200>

export function readMe(params: ReadMeParams): Promise<ReadMeResponse> {
  const url = new URL(`/users/v2/me`, window.location.origin)

  url.search = queryString(params?.query)

  return HttpClient()
    .get<ReadMeResponse>(url.toString())
    .then((res) => res.data)
}

export function readUsers(params: ReadUsersParams): Promise<ReadUsersResponse> {
  const url = new URL(`/users/v2/users`, window.location.origin)
  url.search = queryString({
    ...params.query,
    sort: 'full_name',
    filter: {
      // default to only active users unless we
      // specifically request otherwise
      is_active: true,
      ...params.query.filter,
    },
    page: {
      limit: 500,
      ...params.query.page,
    },
  })

  return HttpClient()
    .get<ReadUsersResponse>(url.toString())
    .then((res) => res.data)
}
